// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"341":"03d01156","787":"a4c484ca"}[chunkId] + ".chunk.js";
};